import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  static targets = ['error', 'preference', 'radioGroup'];

  submitError = ({ detail: [response] }) => {
    const stickerErrors = response?.errors?.sticker;

    // An empty object ({}) is truthy in JS, so guard on its keys too: when the
    // response carries no sticker errors there is nothing for this controller
    // to render.
    if (!stickerErrors || Object.keys(stickerErrors).length === 0) {
      this.clearErrors();
      return;
    }

    ['Email', 'SMS'].forEach((marketingType) => {
      let preference = [].find.call(
        this.preferenceTargets,
        (t) => t.dataset.marketingType === marketingType,
      );

      // The marketing-preferences section is only rendered when the user has
      // not yet answered the marketing questions, so the targets may be absent
      // even though this controller is attached to the form.
      if (!preference) return;

      let key = `allow_${marketingType.toLowerCase()}`;
      if (key in stickerErrors) {
        this.showError(preference, 'is required');
      } else {
        this.hideError(preference);
      }
    });
  };

  clearErrors = () => {
    [].forEach.call(this.preferenceTargets, this.hideError);
  };

  onChangepreference = ({ currentTarget }) => {
    let preference = currentTarget.closest(
      `[data-target="${this.identifier}.preference"]`,
    );
    this.hideError(preference);
  };

  showError = (preference, errorMessage) => {
    let radioGroup = this.getRadioGroup(preference);
    if (radioGroup) radioGroup.classList.add('has-error');

    let errorElement = this.getErrorElement(preference);
    if (!errorElement) return;
    errorElement.textContent = errorMessage;
    errorElement.classList.remove('util-hidden');
  };

  hideError = (preference) => {
    let radioGroup = this.getRadioGroup(preference);
    if (radioGroup) radioGroup.classList.remove('has-error');

    let errorElement = this.getErrorElement(preference);
    if (errorElement) errorElement.classList.add('util-hidden');
  };

  getRadioGroup = (preference) => {
    return preference?.querySelector(
      `[data-target="${this.identifier}.radioGroup"]`,
    );
  };

  getErrorElement = (preference) => {
    return preference?.querySelector(
      `[data-target="${this.identifier}.error"]`,
    );
  };
}
